import { useInterval } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/useI-interval
 */
export default useInterval;
